export default class Footer {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.attachEvents();
  }

  attachEvents() {
    const overlayLinks = Array.prototype.slice.call(document.querySelectorAll(".is-overlay")),
          that = this;

    overlayLinks.forEach(link => {
      const href = link.getAttribute("href");

      link.addEventListener("click", event => {
        event.preventDefault();
        that.showOverlay(href);
      });
    })
  }

  showOverlay(href) {
    const targetOverlay = document.querySelector(href);
    console.log("Target overlay:", targetOverlay);
    document.documentElement.classList.add("overlay-open");
    targetOverlay.classList.add("is-visible");
    this.attachOverlayEvents(targetOverlay);
  }

  attachOverlayEvents(el) {
    const closeButton = el.querySelector("button.close"),
          that = this;

    closeButton.addEventListener("click", event => {
      that.closeOverlay(el);
    });
  }

  closeOverlay(el) {
    const closeButton = el.querySelector("button.close");
    document.documentElement.classList.remove("overlay-open");
    el.classList.remove("is-visible");
    closeButton.removeEventListener("click", event => {
      that.closeOverlay(el);
    });

  }
}
